import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import ForbiddenScreen from "../screens/ForbiddenScreen";

const StoreRoute = () => {
  const { userInfo } = useSelector((state) => state.auth);
  if (!userInfo) return <Navigate to="/login" replace />;

  const dept = (userInfo.primaryDepartment || '').toUpperCase();
  const allowed = userInfo.isAdmin || userInfo.isStore || dept === 'STORE';

  if (!allowed) return <ForbiddenScreen required="store" />;
  return <Outlet />;
};

export default StoreRoute;
